import FilterForm from 'components/forms/FilterForm';
import dayjs from 'dayjs';
import { DatePicker, Form, Input, Select } from 'antd';
import { ForumTable } from 'components/forum/ForumTable';
import { HttpError, useCan } from '@refinedev/core';
import { IForum } from 'interfaces/forum';
import { SearchOutlined } from '@ant-design/icons';
import { forumStatusOptions } from 'constants/admin/forum';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';

interface IFilter {
  title: string;
  status: string;
  startsAt: dayjs.Dayjs;
  endsAt: dayjs.Dayjs;
}

export const TabForum = () => {
  const { id } = useParams();
  const { data: canListForums } = useCan({
    resource: 'forums',
    action: 'list'
  });
  const { tableProps, searchFormProps } = useTable<IForum, HttpError, IFilter>({
    resource: `graduate/courses/${id}/forums`,
    queryOptions: {
      enabled: Boolean(canListForums?.can)
    },
    onSearch: ({ title, status, startsAt, endsAt }) => {
      return [
        {
          field: 'filter[by_title]',
          operator: 'eq',
          value: title
        },
        {
          field: 'filter[by_status]',
          operator: 'eq',
          value: status
        },
        {
          field: 'filter[last_post_starts_at]',
          operator: 'eq',
          value: startsAt
        },
        {
          field: 'filter[last_post_ends_at]',
          operator: 'eq',
          value: endsAt
        }
      ];
    }
  });
  return (
    <>
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="title">
          <Input placeholder="Título do tópico" suffix={<SearchOutlined />} />
        </Form.Item>

        <Form.Item name="startsAt">
          <DatePicker
            className="w-full"
            placeholder="Atualizado a partir de"
            format="DD/MM/YYYY"
          />
        </Form.Item>

        <Form.Item name="endsAt">
          <DatePicker
            className="w-full"
            placeholder="Atualizado até"
            format="DD/MM/YYYY"
          />
        </Form.Item>

        <Form.Item name="status">
          <Select
            options={forumStatusOptions}
            defaultValue={null}
            placeholder="Status"
          />
        </Form.Item>
      </FilterForm>

      <ForumTable tableProps={tableProps} />
    </>
  );
};
